import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import AuthCallback from "./components/AuthCallback";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import Glossary from "./pages/Glossary";
import Categories from "./pages/Categories";
import PhotoScan from "./pages/PhotoScan";
import Materials from "./pages/Materials";
import Pricing from "./pages/Pricing";
import BillingSuccess from "./pages/BillingSuccess";
import Drafts from "./pages/Drafts";
import Quiz from "./pages/Quiz";
import Settings from "./pages/Settings";
import AdminLandingVideo from "./pages/AdminLandingVideo";
import AdminSupport from "./pages/AdminSupport";
import AdminUsers from "./pages/AdminUsers";
import AdminCodes from "./pages/AdminCodes";
import AdminFreeTrial from "./pages/AdminFreeTrial";
import AdminMaintenance from "./pages/AdminMaintenance";
import AdminBroadcast from "./pages/AdminBroadcast";
import AdminAutomation from "./pages/AdminAutomation";
import AuthMagicLink from "./pages/AuthMagicLink";
import Tests from "./pages/Tests";
import Slides from "./pages/Slides";
import Teleprompter from "./pages/Teleprompter";
import Support from "./pages/Support";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import ReminderToasts from "./components/ReminderToasts";
import MaintenanceGate from "./components/MaintenanceGate";
import { Toaster } from "sonner";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: Detect session_id during render (synchronous), prevents race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <MaintenanceGate>
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/magic" element={<AuthMagicLink />} />
      <Route path="/support" element={<Support />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route element={<ProtectedRoute><><ReminderToasts /><Layout /></></ProtectedRoute>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/glossary" element={<Glossary />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/scan" element={<PhotoScan />} />
        <Route path="/materials" element={<Materials />} />
        <Route path="/drafts" element={<Drafts />} />
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/tests" element={<Tests />} />
        <Route path="/slides" element={<Slides />} />
        <Route path="/teleprompter" element={<Teleprompter />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/admin/landing-video" element={<AdminRoute><AdminLandingVideo /></AdminRoute>} />
        <Route path="/admin/support" element={<AdminRoute><AdminSupport /></AdminRoute>} />
        <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
        <Route path="/admin/codes" element={<AdminRoute><AdminCodes /></AdminRoute>} />
        <Route path="/admin/free-trial" element={<AdminRoute><AdminFreeTrial /></AdminRoute>} />
        <Route path="/admin/maintenance" element={<AdminRoute><AdminMaintenance /></AdminRoute>} />
        <Route path="/admin/broadcast" element={<AdminRoute><AdminBroadcast /></AdminRoute>} />
        <Route path="/admin/automation" element={<AdminRoute><AdminAutomation /></AdminRoute>} />
        <Route path="/billing/success" element={<BillingSuccess />} />
      </Route>
    </Routes>
    </MaintenanceGate>
  );
}

export default function App() {
  // Capture ?ref= on first paint so it's persisted even if user wanders
  if (typeof window !== "undefined") {
    try { require("./lib/referral").captureReferralFromUrl(); } catch (_) { /* ignore */ }
  }
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
